module.exports = __webpack_public_path__ + "img/entrepreneur.86cd3000.png";